import * as React from 'react'
import PropTypes from 'prop-types'
import { Button, Stack } from './../components'

export const renderActions = (actions, overrides, distribution, alignment) => {
  if (!actions) return
  if (Array.isArray(actions)) {
    return (
      <Stack vertical distribution={distribution} alignment={alignment}>
        {actions.map((action, index) => {
          // if (index === 0) action.primary = true
          return <React.Fragment key={index}>{renderAction(action, overrides)}</React.Fragment>
        })}
      </Stack>
    )
  } else {
    const action = actions
    action.color = 'primary'
    return renderAction(action, overrides)
  }
}

export const renderAction = ({ content, onAction, ...action }, overrides) => {
  // const Tag = action.href ? 'a' : 'Button'

  return (
    <Button onClick={onAction} {...action} {...overrides}>
      {content}
    </Button>
  )
}
renderAction.propTypes = {
  content: PropTypes.element,
  onAction: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/utils/actions.js